module.exports = __webpack_public_path__ + "img/foro2024_footer_desk.7b694d2d.png";